import React from 'react';
import ItemBox from '../ItemBox';
import {newWords} from './newWords';
import {otherWords} from './otherWords';
import {characterWords} from './characterWords';
import {useParams} from 'react-router-dom';
import './Word.css';

const fullList = newWords.concat(otherWords).concat(characterWords);

export default function Word(props) {
  var {word} = useParams(); // If coming from react router.
  var {search} = props;
  if (!search) {search = (props.word) ? props.word : word;}
  return <ItemBox
    className="word-box"
    preview={false}
    data={props.def}
    list={!props.def ? fullList : null}
    search={search}
    nameName="word"
    propertyName="word"
    alternativesName="match"
    displayName="display"
    headerName="word"
    outsideName="shortdef"
    previewName="etymology"
    textName="def"
    topFootnote={props.topFootnote}
    bottomFootnote={props.bottomFootnote}
  >{props.children}</ItemBox>;
};
